function setWidthBannerProductPicture () {
  const windowWidth = window.innerWidth,
        pics = document.querySelectorAll('.js-banner-product'),
        sm = window.matchMedia('(min-width: 576px)'),
        md = window.matchMedia('(min-width: 768px)');

  if (pics.length > 0) {
    for (let i = 0; i < pics.length; i++) {
      let pic = pics[i];

      if (md.matches) {
        pic.style.width = (windowWidth / (12 / 6)) + 'px';
      } else if (sm.matches) {
        pic.style.width = (windowWidth / (12 / 5)) + 'px';
      } else {
        pic.style.width = (windowWidth / (12 / 4)) + 'px';
      }
    }
  }
}

export {
  setWidthBannerProductPicture
}
